import { css } from "@emotion/react";

export const fullWidthImage = css`
  width: 100%;
`;

export const unorderedList = css`
  list-style-type: disc;
  padding-left: 1rem;
`;
export const qualityProgramWrapper = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const mobileWrapper = css`
  flex-direction: column;
  gap: 1.5rem;
`;

export const qualityProgramColum = css`
  width: calc(50% - 1.25rem);
`;
